import { useState, useCallback, useContext } from "react";

import { plainToClass } from "class-transformer";

import { membershipsApi } from "api";
import { StripePaymentContext, TrackingContext } from "contexts";
import { PaymentDetails } from "models/PaymentDetails";
import { CurrencyCode } from "stores/preferences/currencies";
import { PRODUCTS_NAME } from "types/products";
import { CheckoutActionTypes } from "utils/tracking/reducers/checkoutDataReducer";

const usePromoCode = ({ productName, currency }: { productName: PRODUCTS_NAME; currency: CurrencyCode }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [apiError, setApiError] = useState(false);
  const [promoCodeUsed, setPromoCodeUsed] = useState(false);
  const { checkoutDataDispatch } = useContext(TrackingContext);
  const { setPaymentDetails, paymentIntentId, paymentDetails } = useContext(StripePaymentContext);

  const onSubmit = useCallback(
    async (data: { promoCode: string }) => {
      const { promoCode } = data;

      if (promoCode === "" || promoCodeUsed || !paymentIntentId) {
        return;
      }

      setIsLoading(true);

      const [error, response] = await membershipsApi.applyPromoCode({
        promoCode,
        productName,
        paymentIntentId,
        currency,
      });

      if (response === undefined) {
        setPromoCodeUsed(true);
      }

      if (!error) {
        checkoutDataDispatch({ type: CheckoutActionTypes.Update, payload: { promoCode: data.promoCode } });
        setPaymentDetails(plainToClass(PaymentDetails, response));
      }

      setIsLoading(false);
      setPromoCodeUsed(true);

      if (error) {
        setApiError(true);
      }
    },
    [setIsLoading, setApiError, setPromoCodeUsed, setPaymentDetails, promoCodeUsed, paymentIntentId, paymentDetails]
  );

  return { isLoading, apiError, onSubmit, setPromoCodeUsed, promoCodeUsed, setApiError };
};

export default usePromoCode;
